import { Subscription } from "rxjs";

export const unsubscribe = (...subscription: Subscription[]) => {
  return () => {
    for (let i = 0; i < subscription.length; i++) {
      subscription[i].unsubscribe();
    }
  };
};

export function removeCapitalization(text: string, preserveCaseFor: string[] = []): string {
  if (typeof text !== "string") {
    return '';
  }
  let uncapitalizedText = text.split(' ')
      .map((word, i) => {
      if (i !== 0 && !isAbbreviation(word)) {
        return word.toLowerCase();
      }
      return word;
    }).join(' '); 
  preserveCaseFor.forEach(abb => {
    const re = new RegExp(`${abb}`, 'ig');
    uncapitalizedText = uncapitalizedText.replace(re, abb);
  });
  return uncapitalizedText;
};

function isAbbreviation(word: string): boolean {
  return word.split('').reduce((acc, curr) => {
    if (curr === curr.toUpperCase()) {
      return acc + 1;
    }
    return acc;
  }, 0) > 1;
}